import dayjs from 'dayjs';

// Get 45 days range (from 45 days ago to today)
const get45DaysRange = () => {
  const endDate = dayjs().endOf('day');
  const startDate = dayjs().subtract(45, 'days').startOf('day');
  return [startDate, endDate];
};

// Filter type constants for Orders module
export const FILTER_TYPES = {
    SEARCH: 'search',
    STATUS: 'status',
    DATE_RANGE: 'dateRange',
    SELLER_ACCOUNT: 'sellerAccount',
    CUSTOMIZATION_STATUS: 'customizationStatus',
    PRINTER: 'printer',
    FULFILLMENT_STATUS: 'fulfillmentStatus',
    FULFILLMENT_CHANNEL: 'fulfillmentChannel',
    SHIPMENT_STATUS: 'shipmentStatus',
    SHIPMENT_DETAIL: 'shipmentDetail',
    SUPPORTER: 'supporter',
    CATEGORY: 'category',
    MESSAGE_STATUS: 'messageStatus',
    SHIP_DATE_DUE: 'shipDateDue',
    DELIVERY_DATE_DUE: 'deliveryDateDue',
    CONFIRM_SHIPMENT: 'confirmShipment',
    UPDATED_LAST_MILE: 'updatedLastMile',
    MOCKUP_SENT_AT: 'mockupSentAt',
    TITLE: 'title',
    SELLER_SKU: 'sellerSku',
    EMPLOYEE_ID: 'employeeId',
    EXCLUDE_TITLE: 'excludeTitle',
    EXCLUDE_SELLER_SKU: 'excludeSellerSku',
    BASECOST: 'basecost',
    QUANTITY: 'quantity'
};

// Filter type mapping for better readability and validation
export const FILTER_TYPE_LABELS = {
    [FILTER_TYPES.SEARCH]: 'Search',
    [FILTER_TYPES.STATUS]: 'Status',
    [FILTER_TYPES.DATE_RANGE]: 'Date Range',
    [FILTER_TYPES.SELLER_ACCOUNT]: 'Seller Account',
    [FILTER_TYPES.CUSTOMIZATION_STATUS]: 'Customization Status',
    [FILTER_TYPES.PRINTER]: 'Printer',
    [FILTER_TYPES.FULFILLMENT_STATUS]: 'Fulfillment Status',
    [FILTER_TYPES.FULFILLMENT_CHANNEL]: 'Fulfillment Channel',
    [FILTER_TYPES.SHIPMENT_STATUS]: 'Shipment Status',
    [FILTER_TYPES.SHIPMENT_DETAIL]: 'Shipment Details',
    [FILTER_TYPES.SUPPORTER]: 'Supporter',
    [FILTER_TYPES.CATEGORY]: 'Category',
    [FILTER_TYPES.MESSAGE_STATUS]: 'Message Status',
    [FILTER_TYPES.SHIP_DATE_DUE]: 'Ship Date Due',
    [FILTER_TYPES.DELIVERY_DATE_DUE]: 'Delivery Date Due',
    [FILTER_TYPES.CONFIRM_SHIPMENT]: 'Confirm Shipment',
    [FILTER_TYPES.UPDATED_LAST_MILE]: 'Updated Last Mile',
    [FILTER_TYPES.MOCKUP_SENT_AT]: 'Mockup Sent At',
    [FILTER_TYPES.TITLE]: 'Title',
    [FILTER_TYPES.SELLER_SKU]: 'Seller SKU',
    [FILTER_TYPES.EMPLOYEE_ID]: 'Employee ID',
    [FILTER_TYPES.EXCLUDE_TITLE]: 'Exclude Title',
    [FILTER_TYPES.EXCLUDE_SELLER_SKU]: 'Exclude Seller SKU',
    [FILTER_TYPES.BASECOST]: 'Base Cost',
    [FILTER_TYPES.QUANTITY]: 'Qty'
};

// Default filter values
export const DEFAULT_FILTER_VALUES = {
    [FILTER_TYPES.SEARCH]: '',
    [FILTER_TYPES.STATUS]: [],
    [FILTER_TYPES.DATE_RANGE]: get45DaysRange(),
    [FILTER_TYPES.SELLER_ACCOUNT]: [],
    [FILTER_TYPES.CUSTOMIZATION_STATUS]: 'all',
    [FILTER_TYPES.PRINTER]: [],
    [FILTER_TYPES.FULFILLMENT_STATUS]: 'all',
    [FILTER_TYPES.FULFILLMENT_CHANNEL]: 'all',
    [FILTER_TYPES.SHIPMENT_STATUS]: [],
    [FILTER_TYPES.SHIPMENT_DETAIL]: 'all',
    [FILTER_TYPES.SUPPORTER]: 'all',
    [FILTER_TYPES.CATEGORY]: [],
    [FILTER_TYPES.MESSAGE_STATUS]: 'all',
    [FILTER_TYPES.SHIP_DATE_DUE]: 'all',
    [FILTER_TYPES.DELIVERY_DATE_DUE]: 'all',
    [FILTER_TYPES.CONFIRM_SHIPMENT]: 'all',
    [FILTER_TYPES.UPDATED_LAST_MILE]: 'all',
    [FILTER_TYPES.MOCKUP_SENT_AT]: 'all',
    [FILTER_TYPES.TITLE]: '',
    [FILTER_TYPES.SELLER_SKU]: '',
    [FILTER_TYPES.EMPLOYEE_ID]: '',
    [FILTER_TYPES.EXCLUDE_TITLE]: '',
    [FILTER_TYPES.EXCLUDE_SELLER_SKU]: '',
    [FILTER_TYPES.BASECOST]: 'all',
    [FILTER_TYPES.QUANTITY]: null
};

// Validate filter type
export const isValidFilterType = (filterType) => {
    return Object.values(FILTER_TYPES).includes(filterType);
};
